import {Navigate} from "react-router-dom";

import {
  dispatchCenterRequiresShift,
  isDispatchOperatorRole,
} from "@/src/modules/core/lib/dispatch-center-policy";
import {useStoredMe} from "@/src/modules/core/store/me";
import {OfficerHome} from "@/src/modules/officer/pages";

import {shiftsService} from "../../shifts/services";
import ResidentHome from "./resident-home";

export default function HomePage() {
  const user = useStoredMe();
  const isShiftsEnabledForRole = shiftsService.isShiftsHomeRole(user);

  if (user?.isResident) {
    return <ResidentHome />;
  }

  if (isDispatchOperatorRole(user)) {
    if (dispatchCenterRequiresShift(user)) {
      return <OfficerHome />;
    }
    return <Navigate to="/dispatchdesk" replace />;
  }

  if (isShiftsEnabledForRole) {
    return <OfficerHome />;
  }

  return <Navigate to={user?.isAdmin ? "/dashboard" : "/dars"} replace />;
}
